import { useCallback, useRef, useState } from 'react';

import { RowId } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/types';

export function useRowExpandOverrides() {
  const [overrides, setOverrides] = useState<Record<RowId, boolean>>({});
  const overridesRef = useRef<Record<RowId, boolean>>({});

  const setOverride = useCallback((rowId: RowId, value: boolean) => {
    overridesRef.current = { ...overridesRef.current, [rowId]: value };
    setOverrides(prev => ({ ...prev, [rowId]: value }));
  }, []);

  const clearOverrides = useCallback(() => {
    overridesRef.current = {};
    setOverrides({});
  }, []);

  const getDesired = useCallback((rowId: RowId, expandAll: boolean) => {
    const ref = overridesRef.current;
    if (Object.prototype.hasOwnProperty.call(ref, rowId)) return ref[rowId];
    return expandAll;
  }, []);

  return { overrides, setOverride, clearOverrides, getDesired };
}
